// Aviso local (en este navegador) de que el paciente ha abierto una actividad
// marcada como "New!". La barra lateral lo escucha para actualizar la insignia
// de Activity plan sin recargar.
const listeners = new Set();

export const emitActivityViewed = () => listeners.forEach((listener) => listener());

// Devuelve la función para darse de baja (se puede retornar tal cual desde useEffect).
export const onActivityViewed = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
